/**
 * Common app actions
 */
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SHOW_MODAL_TOP = 'SHOW_MODAL_TOP';
export const HIDE_MODAL_TOP = 'HIDE_MODAL_TOP';
export const SET_MODAL_CLOSE_CONFIRMATION = 'SET_MODAL_CLOSE_CONFIRMATION';

export const setLoading = (type, status) => ({
  type,
  status,
});

export const showModal = (modal, modalProps) => ({
  type: SHOW_MODAL,
  modal,
  modalProps,
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});

export const showModalTop = (modal, modalProps) => ({
  type: SHOW_MODAL_TOP,
  modal,
  modalProps,
});

export const hideModalTop = () => ({
  type: HIDE_MODAL_TOP,
});

export const setModalCloseConfirmation = confirmation => ({
  type: SET_MODAL_CLOSE_CONFIRMATION,
  confirmation,
});
